import { Box } from '@material-ui/core'
import { Button, Modal, Typography } from 'src/modules/core/components'
import classes from './install-chrome-extension-modal.module.scss'

const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/reminders-for-google-cale/oolbjiianecoijlgkhopbmhnliajjnnm?utm_source=webapp&utm_medium=link&utm_campaign=Chrome+Extension'

export interface InstallChromeExtensionModalProps {
  open: boolean
  onClose: () => void
}

export function InstallChromeExtensionModal({ open, onClose }: InstallChromeExtensionModalProps) {
  if (!open) {
    return null
  }

  return (
    <Modal
      style={{ maxWidth: '800px' }}
      closeOnBackdropClick={false}
      onClose={onClose}
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          Set Reminders While Creating Appointments
        </Typography>
      }
    >
      <Box display="flex" flexDirection="column" gridGap={20}>
        <Typography variant="body" className={classes.modalText}>
          You can set reminders while creating appointments in your Google Calendar without changing your workflow.
        </Typography>

        <Typography variant="body" className={classes.modalText}>
          Our{' '}
          <a href={CHROME_EXTENSION_URL} target="_blank" rel="noopener noreferrer">
            Chrome extension
          </a>{' '}
          will add custom fields to your Google Calendar appointment editing screen and let you set & customize your
          reminder messages <strong>without leaving your calendar</strong>.
        </Typography>

        <img
          className={classes.image}
          src="https://firebasestorage.googleapis.com/v0/b/recordatorio-de-cita.appspot.com/o/install-chrome-extension-modal-content-image.png?alt=media&token=ec0e798b-b8c6-4667-8c96-119d14ce8f01"
          alt="Chrome Extension Modal"
        />

        <Button type="button" className={classes.button} onClick={() => window.open(CHROME_EXTENSION_URL, '_blank')}>
          Install Chrome Extension
        </Button>
      </Box>
    </Modal>
  )
}
